import styled, { css } from 'styled-components';
import { typography, textColorVariables, colors } from '@izettle/otto';
import { marginTopBottomMixin } from '../../mixins.js';

const setTextVariableColor = (textColorVariable, textColor) => `${textColorVariables[textColorVariable]}: ${colors.text[textColor]};`;
const whiteTextMixin = css`
  -webkit-font-smoothing: antialiased;
  ${setTextVariableColor("primary", "inverted")}
  ${setTextVariableColor("secondary", "inverted")}
`;
const textColorMixin = color => css`
  ${setTextVariableColor("primary", color)}
  ${setTextVariableColor("secondary", color)}
`;

// prettier-ignore
const Text = {
  Huge: styled.p.withConfig({
    displayName: "text__Huge",
    componentId: "zettle__sc-7a9wp7-0"
  })(["", " ", ""], typography.huge, marginTopBottomMixin({
    top: "xLarge",
    bottom: "xxSmall"
  })),
  Title1: styled.h1.withConfig({
    displayName: "text__Title1",
    componentId: "zettle__sc-7a9wp7-1"
  })(["", " ", ""], typography.title1, marginTopBottomMixin({
    top: "large",
    bottom: "none"
  })),
  Title2: styled.h2.withConfig({
    displayName: "text__Title2",
    componentId: "zettle__sc-7a9wp7-2"
  })(["", " ", ""], typography.title2, marginTopBottomMixin({
    top: "large",
    bottom: "none"
  })),
  Title3: styled.h3.withConfig({
    displayName: "text__Title3",
    componentId: "zettle__sc-7a9wp7-3"
  })(["", " ", ""], typography.largeBold, marginTopBottomMixin({
    top: "large",
    bottom: "none"
  })),
  Large: styled.p.withConfig({
    displayName: "text__Large",
    componentId: "zettle__sc-7a9wp7-4"
  })(["", " ", ""], typography.large, marginTopBottomMixin({
    top: "xxSmall",
    bottom: "small"
  })),
  LargeBold: styled.p.withConfig({
    displayName: "text__LargeBold",
    componentId: "zettle__sc-7a9wp7-5"
  })(["", " ", ""], typography.largeBold, marginTopBottomMixin({
    top: "xxSmall",
    bottom: "small"
  })),
  Regular: styled.p.withConfig({
    displayName: "text__Regular",
    componentId: "zettle__sc-7a9wp7-6"
  })(["", " ", ""], typography.regular, marginTopBottomMixin({
    top: "tiny",
    bottom: "small"
  })),
  RegularBold: styled.p.withConfig({
    displayName: "text__RegularBold",
    componentId: "zettle__sc-7a9wp7-7"
  })(["", " ", ""], typography.regularBold, marginTopBottomMixin({
    top: "tiny",
    bottom: "small"
  })),
  RegularSecondary: styled.p.withConfig({
    displayName: "text__RegularSecondary",
    componentId: "zettle__sc-7a9wp7-8"
  })(["", " ", ""], typography.regularSecondary, marginTopBottomMixin({
    top: "tiny",
    bottom: "small"
  })),
  RegularLongText: styled.p.withConfig({
    displayName: "text__RegularLongText",
    componentId: "zettle__sc-7a9wp7-9"
  })(["", " ", ""], typography.regularLongText, marginTopBottomMixin({
    top: "tiny",
    bottom: "small"
  })),
  Small: styled.p.withConfig({
    displayName: "text__Small",
    componentId: "zettle__sc-7a9wp7-10"
  })(["", " ", ""], typography.small, marginTopBottomMixin({
    top: "xxSmall",
    bottom: "small"
  })),
  SmallBold: styled.p.withConfig({
    displayName: "text__SmallBold",
    componentId: "zettle__sc-7a9wp7-11"
  })(["", " ", ""], typography.smallBold, marginTopBottomMixin({
    top: "xxSmall",
    bottom: "small"
  })),
  SmallSecondary: styled.p.withConfig({
    displayName: "text__SmallSecondary",
    componentId: "zettle__sc-7a9wp7-12"
  })(["", " ", ""], typography.smallSecondary, marginTopBottomMixin({
    top: "xxSmall",
    bottom: "small"
  })),
  SmallCaps: styled.p.withConfig({
    displayName: "text__SmallCaps",
    componentId: "zettle__sc-7a9wp7-13"
  })(["", " ", ""], typography.smallCaps, marginTopBottomMixin({
    top: "xSmall",
    bottom: "xSmall"
  })),
  SmallCapsSecondary: styled.p.withConfig({
    displayName: "text__SmallCapsSecondary",
    componentId: "zettle__sc-7a9wp7-14"
  })(["", " ", ""], typography.smallCapsSecondary, marginTopBottomMixin({
    top: "xSmall",
    bottom: "xSmall"
  })),
  Mini: styled.p.withConfig({
    displayName: "text__Mini",
    componentId: "zettle__sc-7a9wp7-15"
  })(["", " ", ""], typography.mini, marginTopBottomMixin({
    top: "xSmall",
    bottom: "small"
  }))
};

export { Text, textColorMixin, whiteTextMixin };
//# sourceMappingURL=index.js.map
